export const WalletLayout = lazy(() => import('./routes/Layout').then((m) => ({ default: m.default })));
export const WalletBuyCrypto = lazy(() => import('./routes/buycrypto').then((m) => ({ default: m.default })));
export const WalletDeposit = lazy(() => import('./routes/deposit').then((m) => ({ default: m.default })));

export const WalletSwap = lazy(() => import('./routes/swap').then((m) => ({ default: m.default })));
export const WalletTransaction = lazy(() => import('./routes/transaction').then((m) => ({ default: m.default })));
export const WalletWithdraw = lazy(() => import('./routes/withdraw').then((m) => ({ default: m.default })));
export const WalletEnter = lazy(() => import('./routes/Enter').then((m) => ({ default: m.default })));
// export const WalletBalance = lazy(() => import('./routes/balance').then((m) => ({ default: m.default })));
export { default as WalletBalance } from './routes/balance';

export const WalletFlow = lazy(() => import('./routes/balance/flow').then((m) => ({ default: m.default })));
export const WalletPreferences = lazy(() => import('./routes/preferences'));
export const WalletVault = lazy(() => import('./routes/vault'));
export const VaultDeposit = lazy(() => import('./routes/vault/deposit'));
export const VaultWithdraw = lazy(() => import('./routes/vault/withdraw'));

export const DepositWayDialog = lazy(() => import('./routes/dialog/DepositWay'));
export const WalletDepositWay = lazy(() => import('./routes/deposit/DepositWayPage'));
// 产品zim反馈首次加载慢，去掉lazy加载，改为正常导出
// export const DepositDialog = lazy(() => import('./routes/dialog/Deposit'));
export { default as DepositDialog } from './routes/dialog/Deposit';
export const WithdrawDialog = lazy(() => import('./routes/dialog/Withdraw'));
export const WithdrawFiatPaymethodsDialog = lazy(() => import('./routes/dialog/WithdrawFiatPaymethods'));
export const WithdrawFiatConfirmDialog = lazy(() => import('./routes/dialog/WithdrawFiatConfirm'));
export const RepayCreditDialog = lazy(() => import('./routes/dialog/Repayment'));
export const BalanceRepayDialog = lazy(() => import('./routes/dialog/WalletRepay'));
export const MyStatementDialog = lazy(() => import('./routes/dialog/Statement'));
export const FiatFormDialog = lazy(() => import('./routes/dialog/FiatForm'));
export const VipCredit = lazy(() => import('./routes/VipCredit'));
export const Transaction = lazy(() => import('./routes/transaction-history'));

export const ManageAssets = lazy(() => import('./components/ui/ManageAssets'));
export const HowToDeposit = lazy(() => import('./routes/dialog/how-to-deposit'));
export const DepositDetail = lazy(() => import('./routes/deposit/transaction/details'));
export const WithdrawDetail = lazy(() => import('./routes/withdraw/transaction/details'));
export const DevApp = lazy(() => import('./routes/Dev').then((m) => ({ default: m.default })));

export const ResponsibleLayout = lazy(() => import('./routes/Layout').then((m) => ({ default: m.default })));
